import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Every move to another page starts at its top (Devin 2026-10-16: "For
// organisers", clicked halfway down the home page, opened halfway down).
// Left alone: links to a #section (the page scrolls there itself), the back
// and forward buttons (the browser puts the reader back where they were),
// and changes that keep the same page (search, filters).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    if (type !== "POP" && !hash) window.scrollTo(0, 0);
    // only a new page counts, not a hash or query change on the same one
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
};

export default ScrollToTop;
